"use client";

import { c as _c } from "react/compiler-runtime";
import { useFilterSearchMapPins } from "@repo/design-system/hooks/use-filter-search-map-pins";
import { useToggleMap } from "@repo/design-system/hooks/use-toggle-map";
import type { LeafletMapProps } from "@repo/design-system/types/leaflet";
import { cn } from "@repo/design-system/utils/cn";
import dynamic from "next/dynamic";
import { useLanguage } from "~/translations/loader/use-language";
function BlueBackground() {
  const $ = _c(3);
  const t = useLanguage();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = cn("grid h-full place-content-center bg-[#aad3df]");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t.map_loading) {
    t1 = <div className={t0}><p className="p-5">{t.map_loading}</p></div>;
    $[1] = t.map_loading;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
const Leaflet = dynamic(() => import("./leaflet-map").then(mod => mod.LeafletMap), {
  ssr: false,
  loading: BlueBackground
});

// Only mounted when the map is visible, so the (potentially large) map-pins
// query is never fired while the map is collapsed on initial page load.
function VisibleMap(t0) {
  const $ = _c(6);
  const {
    center,
    zoom,
    branches,
    children
  } = t0;
  const jobPins = useFilterSearchMapPins();
  let t1;
  if ($[0] !== branches || $[1] !== center || $[2] !== children || $[3] !== jobPins || $[4] !== zoom) {
    t1 = <Leaflet branches={branches} center={center} heightClass="h-map-small md:h-map-large" jobPins={jobPins} zoom={zoom}>{children}</Leaflet>;
    $[0] = branches;
    $[1] = center;
    $[2] = children;
    $[3] = jobPins;
    $[4] = zoom;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export function LazyMap(t0) {
  const $ = _c(14);
  const {
    center,
    zoom,
    branches,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      initiallyOpen: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    isMapVisible,
    hasMounted
  } = useToggleMap(t1);
  if (!hasMounted) {
    return null;
  }
  const t2 = !isMapVisible;
  const t3 = !isMapVisible;
  let t4;
  if ($[1] !== isMapVisible || $[2] !== t3) {
    t4 = cn("w-full overflow-hidden bg-[#aad3df] transition-all duration-700 ease-in-out", {
      "h-map-small md:h-map-large": isMapVisible,
      "h-0": t3
    });
    $[1] = isMapVisible;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== branches || $[5] !== center || $[6] !== children || $[7] !== isMapVisible || $[8] !== zoom) {
    t5 = isMapVisible && <VisibleMap branches={branches} center={center} zoom={zoom}>{children}</VisibleMap>;
    $[4] = branches;
    $[5] = center;
    $[6] = children;
    $[7] = isMapVisible;
    $[8] = zoom;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t5) {
    t6 = <div aria-hidden={t2} className={t4} id="jobMapWrapper">{t5}</div>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}